import { ComponentType } from 'react'

export interface BottomPanelOwnProps {
  content: ComponentType<any> | null
  open: boolean
  maximized: boolean
  title: string
  testId: string | null
  displayCloseButton: boolean
  onRequestClose: () => void
  onRequestExpand: () => void
}

export const BOTTOM_PANEL_CONTENT_ROOT = 'bottomPanelContentRoot'
